// University of Kentucky's bachelor's majors (#2839). Read on 2026-10-01
// from UK's official 2026-2027 Undergraduate Catalog (catalogs.uky.edu,
// catoid=22): each college's Programs list under "Programs by College",
// checked line for line against the catalog's "Programs by Degree" page
// (157 bachelor's programs; every one appears below exactly once). The
// College of Arts and Sciences page lists only seven college-level programs
// and names its departments' majors in its departmental honors table, so the
// Arts and Sciences group is the Programs by Degree entries no other college
// lists; Applied Psychology (Department of Psychology) and Mapping and
// GIScience (GEO courses) were checked on their program pages. Public
// Policy, B.A. sits on no college page; the Martin School of Public Policy
// and Administration's own site offers it, so it is grouped there.
// Agricultural Ecosystem Sciences is listed under the college's Department
// of Plant and Soil Sciences. Each catalog line is one entry, with the
// catalog's degree abbreviation (B.A., B.S., B.A.E., B.S.E., B.B.A.,
// B.S.B.A., B.S.B.E., B.F.A., B.M., B.H.S., B.P.H., B.L.S., B.S.N.,
// A.B.S.N., R.N.-B.S.N.), including online and Paducah versions and the
// chemistry options the catalog lists separately. Left out: minors,
// certificates, badges, non-degree programs and the music education
// four-year-plan pages. Curly apostrophes and en dashes in names are typed
// as ASCII.
const majors = {
    "slug": "university-of-kentucky",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in UK's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Martin-Gatton College of Agriculture, Food and Environment",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, Martin-Gatton College of Agriculture, Food and Environment",
                "url": "https://catalogs.uky.edu/content.php?catoid=22&navoid=1300"
            },
            "majors": [
                {
                    "name": "Agricultural and Medical Biotechnology",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Education and Advocacy",
                    "degree": "B.S."
                },
                {
                    "name": "Agriculture: Individualized Programs",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Community and Leadership Development",
                    "degree": "B.S."
                },
                {
                    "name": "Dietetics",
                    "degree": "B.S."
                },
                {
                    "name": "Dietetics: Accelerated Coordinated Program in Dietetics (ACP)",
                    "degree": "B.S."
                },
                {
                    "name": "Equine Science and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Family Financial Counseling",
                    "degree": "B.S."
                },
                {
                    "name": "Family Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Food Biosciences",
                    "degree": "B.S."
                },
                {
                    "name": "Forestry",
                    "degree": "B.S."
                },
                {
                    "name": "Horticultural Science",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality Management and Tourism",
                    "degree": "B.S."
                },
                {
                    "name": "Human Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "B.S."
                },
                {
                    "name": "Merchandising, Apparel, and Textiles",
                    "degree": "B.S."
                },
                {
                    "name": "Natural Resources and Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainable Agriculture and Community Food Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Ecosystem Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, Programs by Degree",
                "url": "https://catalogs.uky.edu/content.php?catoid=22&navoid=1328"
            },
            "note": "The catalog's Arts and Sciences page lists its departments' majors in its honors table rather than as program links, so these are the catalog's Programs by Degree entries that no other college lists.",
            "majors": [
                {
                    "name": "African American and Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental and Sustainability Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Foreign Language and International Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Gender and Women's Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Health, Society, and Populations",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Law and Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mapping and GIScience",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Modern and Classical Languages, Literatures and Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "US Culture and Business Practices",
                    "degree": "B.A."
                },
                {
                    "name": "Writing, Rhetoric, and Digital Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.L.S."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry: Biochemistry Option",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry: Materials Option",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry: Traditional Option",
                    "degree": "B.S."
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.S."
                },
                {
                    "name": "Foreign Language and International Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.S."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.S."
                },
                {
                    "name": "Mapping and GIScience",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Modern and Classical Languages, Literatures and Cultures",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Writing, Rhetoric, and Digital Studies",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Gatton College of Business and Economics",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, Gatton College of Business and Economics",
                "url": "https://catalogs.uky.edu/content.php?catoid=22&navoid=1303"
            },
            "majors": [
                {
                    "name": "General Business",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.B.E."
                },
                {
                    "name": "Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                }
            ]
        },
        {
            "name": "College of Communication and Information",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, College of Communication and Information",
                "url": "https://catalogs.uky.edu/content.php?catoid=22&navoid=1308"
            },
            "majors": [
                {
                    "name": "Information Communication Technology - Online Program",
                    "degree": "B.A."
                },
                {
                    "name": "Information Communication Technology",
                    "degree": "B.A."
                },
                {
                    "name": "Information Communication Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Media Arts and Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.S."
                },
                {
                    "name": "Media Arts and Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Communication: Human Communication Online Option",
                    "degree": "B.A."
                },
                {
                    "name": "Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Communication: Human Communication Online Option",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Strategic Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Integrated Strategic Communication",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Design",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, College of Design",
                "url": "https://catalogs.uky.edu/content.php?catoid=22&navoid=1306"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.A."
                },
                {
                    "name": "Interiors: Planning/Strategy/Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Product Design",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, College of Education",
                "url": "https://catalogs.uky.edu/content.php?catoid=22&navoid=1309"
            },
            "majors": [
                {
                    "name": "Learning and Behavior Disorders and Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Disability Studies",
                    "degree": "B.A.E."
                },
                {
                    "name": "Interdisciplinary Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Early Childhood Education, Non-Teacher Certification",
                    "degree": "B.S.E."
                },
                {
                    "name": "Leadership for Community Education and Human Learning: Non-Teaching Certification Program",
                    "degree": "B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S."
                },
                {
                    "name": "Sport Leadership and Management",
                    "degree": "B.A.E."
                },
                {
                    "name": "Kinesiology with Options in Exercise Science and Strength and Conditioning",
                    "degree": "B.S."
                },
                {
                    "name": "Health Education Teacher Education",
                    "degree": "B.S.E."
                },
                {
                    "name": "Health Promotion - Non-Teacher Certification",
                    "degree": "B.S.E."
                },
                {
                    "name": "Kinesiology: Physical Education Teacher Education",
                    "degree": "B.S.E."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A.E."
                },
                {
                    "name": "Middle Level Education",
                    "degree": "B.A.E."
                },
                {
                    "name": "Secondary English Education",
                    "degree": "B.A.E."
                },
                {
                    "name": "Secondary Social Studies Education",
                    "degree": "B.A.E."
                },
                {
                    "name": "STEM Education",
                    "degree": "B.S.E."
                }
            ]
        },
        {
            "name": "Stanley and Karen Pigman College of Engineering",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, Stanley and Karen Pigman College of Engineering",
                "url": "https://catalogs.uky.edu/content.php?catoid=22&navoid=1310"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering (Paducah)",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Materials Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering Technology (Paducah)",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Lean Systems Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering (Paducah)",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mining Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biosystems Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, College of Fine Arts",
                "url": "https://catalogs.uky.edu/content.php?catoid=22&navoid=1311"
            },
            "majors": [
                {
                    "name": "Art Education",
                    "degree": "B.A."
                },
                {
                    "name": "Art History & Visual Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art Studio",
                    "degree": "B.A."
                },
                {
                    "name": "Film and Sonic Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art Studio",
                    "degree": "B.F.A."
                },
                {
                    "name": "Digital Media Design",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Arts Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Music Industry",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Health Sciences",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, College of Health Sciences",
                "url": "https://catalogs.uky.edu/content.php?catoid=22&navoid=1312"
            },
            "majors": [
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "B.H.S."
                },
                {
                    "name": "Clinical Leadership and Management",
                    "degree": "B.H.S."
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "B.H.S."
                },
                {
                    "name": "Human Health Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, College of Nursing",
                "url": "https://catalogs.uky.edu/preview_entity.php?catoid=22&ent_oid=2575"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "A.B.S.N."
                },
                {
                    "name": "Surgical First Assistant",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nursing",
                    "degree": "R.N.-B.S.N."
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, College of Pharmacy",
                "url": "https://catalogs.uky.edu/preview_entity.php?catoid=22&ent_oid=2576"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Public Health",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, College of Public Health",
                "url": "https://catalogs.uky.edu/preview_entity.php?catoid=22&ent_oid=2577"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "B.P.H."
                }
            ]
        },
        {
            "name": "College of Social Work",
            "source": {
                "label": "UK 2026-2027 Undergraduate Catalog, College of Social Work",
                "url": "https://catalogs.uky.edu/preview_entity.php?catoid=22&ent_oid=2578"
            },
            "majors": [
                {
                    "name": "Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Martin School of Public Policy and Administration",
            "source": {
                "label": "Martin School of Public Policy and Administration, BA in Public Policy",
                "url": "https://martin.uky.edu/programs/ba-public-policy"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
